import { useEffect, useState } from 'react';
import Firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export default function useShopStandaloneCarts(shopId, rowsCount, filter) {
      const { hostId, range } = filter;

      const [standaloneCarts, setStandaloneCarts] = useState([]);
      const [loading, setLoading] = useState(false);
      const [getNextCarts, setNextCarts] = useState(null);

      const getQuery = (cursor) => {
            let q = Firebase
                  .firestore()
                  .collection('shops')
                  .doc(shopId)
                  .collection('carts')
                  .where('cartType', '==', 'standaloneCart');

            if (range) {
                  const start = range.start.set({hour: 0, minutes: 0, seconds: 0}).toDate();
                  const end = range.end.set({hour: 23, minutes: 59, seconds: 59}).toDate();
                  q = q
                        .where('createdAt', '<=', end)
                        .where('createdAt', '>=', start)
            }

            if (hostId) {
                  q = q.where('createdByUser', '==', hostId);
            }

            q = q.orderBy('createdAt', 'desc');

            if (cursor) {
                  q = q.startAt(cursor);
            }

            return q;
      };

      const getCarts = async (shopId, limit, cursor = null) => {
            setLoading(true);
            const q = getQuery(cursor);
            const querySnap = await q.limit(limit + 1).get();
            const docs = querySnap.docs;
            let next = null;

            if (querySnap.size > limit) {
                  const nextCursor = docs.pop();
                  next = () => () => getCarts(shopId, limit, nextCursor);
            }

            return { docs, next };
      };

      useEffect(() => {
            getCarts(shopId, rowsCount * 2, null).then(({ docs, next }) => {
                  setStandaloneCarts([...docs]);
                  setNextCarts(next);
                  setLoading(false);
            });
      }, []);

      const refresh = () => {
            getCarts(shopId, rowsCount * 2, null).then(({ docs, next }) => {
                  setStandaloneCarts([...docs]);
                  setNextCarts(next);
                  setLoading(false);
            });
      };

      const getMoreCarts = () => {
            if (getNextCarts) {
                  getNextCarts().then(({ docs, next }) => {
                        setStandaloneCarts([...standaloneCarts, ...docs]);
                        setNextCarts(next);
                  });
            }
      };

      const getHistoryCarts = async (limit, cursor = null) => {
            const query = getQuery(cursor);
            const querySnap = await query.limit(limit + 1).get();
            const docs = querySnap.docs;
            let next = null;

            if (querySnap.size > limit) {
                  const nextCursor = docs.pop();
                  next = () => getHistoryCarts(limit, nextCursor);
            }

            return { docs, next };
      };

      return { standaloneCarts, loading, refresh, getMoreCarts, getHistoryCarts };
}
